<template>
<div>
  <div class="content has-text-centered has-background-white">
    <img src="../assets/mperaheader.png" height="100px">
  </div>
  <!-- <section class="section has-background-grey-lighter"> -->

    <br>
    <div class="container">
        <div class="content has-text-centered">
          <h5 class="title is-5">{{this.calcData.retTypeDescription}}</h5>
        </div>

      <!-- ============================================================================================================= -->
      <div class="box">
      <table class="table is-fullwidth">
      <tbody>
      <tr>
        <th>Option 1 <sup style="color: red;">1</sup></th>
        <th>Option 2 <sup style="color: red;">2</sup></th>
        <th>Option 3 <sup style="color: red;">3</sup></th>
        <th>Opt. 4 - 10 yr Certain<sup style="color: red;">4a</sup></th>
        <th>Opt. 4 - 20 yr Certain<sup style="color: red;">4b</sup></th>
      </tr>
      <tr>
        <td class="has-text-link has-text-weight-bold">{{currencyFormat(this.calcData.opt1)}}</td>

        <td v-if="this.calcData.chkspouse != true && ((this.calcData.memberage_at_ret - this.calcData.beneage_at_ret) > 10)" class="has-text-link has-text-weight-bold">N/A*</td>
        <td v-else class="has-text-link has-text-weight-bold">{{currencyFormat(this.calcData.opt2)}}</td>

        <td v-if="this.calcData.chkspouse != true && ((this.calcData.memberage_at_ret - this.calcData.beneage_at_ret) > 10)" class="has-text-link has-text-weight-bold">N/A*</td>
        <td v-else class="has-text-link has-text-weight-bold">{{currencyFormat(this.calcData.opt3)}}</td>

        <td v-if="this.calcData.opt410 == 0" class="has-text-link has-text-weight-bold">N/A</td>
        <td v-else class="has-text-link has-text-weight-bold">{{currencyFormat(this.calcData.opt410)}}</td>
        <td v-if="this.calcData.opt420 == 0" class="has-text-link has-text-weight-bold">N/A</td>
        <td v-else class="has-text-link has-text-weight-bold">{{currencyFormat(this.calcData.opt420)}}</td>
      </tr>
      </tbody>
      </table>
      </div>
      <!-- ============================================================================================================= -->
      <div class="content has-text-centered">
        <h6 v-if="this.calcData.chkspouse != true && this.calcData.beneage_at_ret > 0 && ((this.calcData.memberage_at_ret - this.calcData.beneage_at_ret) > 10)"class="title is-6">* Options 2 and 3 not available as member is more than 10 years older than contingent annuitant.</h6>
        <h6 v-if="this.calcData.beneage_at_ret == 0" class="title is-6">* Options 2 and 3 not available as no contingent annuitant birthdate was entered..</h6>
        <h6 class="title is-6">Above <b><i>Estimate</i></b> is based on assumptions/data below:</h6>
      </div>

      <div class="box">
        <table class="table is-fullwidth">
      <tbody>
      <tr>
      <!-- <td style="width: 37px;">HAC</td> -->
      <th style="width: 107px;">HAC</th>
      <th style="width: 107px;">Tot. Serv. Credit</th>
      <th style="width: 97px;">Tot. Mbr. Serv.</th>
      <th style="width: 41px;">Multi.</th>
      <th style="width: 67px;">Hire Date</th>
      <th style="width: 67px;">Ret. Date</th>
      <th style="width: 157px;">Memb/Bene ages (at Ret.)</th>
      </tr>
      <tr>
      <td class="has-text-link has-text-weight-bold" style="width: 37px;">{{currencyFormat(calcData.hac)}}</td>
      <td class="has-text-link has-text-weight-bold" style="width: 107px;">{{calcData.totServCredit.toFixed(2)}}</td>
      <td class="has-text-link has-text-weight-bold" style="width: 97px;">{{calcData.totMembServ.toFixed(2)}}</td>
      <td class="has-text-link has-text-weight-bold" style="width: 41px;">{{calcData.muliplier.toFixed(4)}}</td>
      <td class="has-text-link has-text-weight-bold" style="width: 67px;">{{calcData.hiredate.toLocaleDateString("en-US")}}</td>
      <td class="has-text-link has-text-weight-bold" style="width: 67px;">{{calcData.retDate.toLocaleDateString("en-US")}}</td>
      <td class="has-text-link has-text-weight-bold" style="width: 157px;">&nbsp;{{calcData.memberage_at_ret}}/{{calcData.beneage_at_ret}}</td>
      </tr>
      </tbody>
      </table>
    </div>

    <!-- ============================================================================================================= -->

    <div class="box">
      <table class="table is-fullwidth">
    <tbody>
    <tr>
    <th style="width: 37px;">Cur. Serv. Credit</th>
    <th style="width: 107px;">Cur Mbr. Serv</th>
    <th style="width: 97px;">Serv. Credit Purch.</th>
    <th style="width: 41px;">Mbr Serv. Purch.</th>
    <th style="width: 67px;">Yrs. to Ret.</th>
    <th v-if="this.calcData.erf < 1" style="width: 67px;">ERF Factor</th>
    <th style="width: 157px;">Salary Incr. %</th>
    </tr>
    <tr>
    <td class="has-text-link has-text-weight-bold" style="width: 37px;">{{this.calcData.scDecimal.toFixed(2)}}</td>
    <td class="has-text-link has-text-weight-bold" style="width: 107px;">{{this.calcData.msDecimal.toFixed(2)}}</td>
    <td class="has-text-link has-text-weight-bold" style="width: 97px;">{{this.calcData.scDecimalPurchase.toFixed(2)}}</td>
    <td class="has-text-link has-text-weight-bold" style="width: 41px;">{{this.calcData.msDecimalPurchase.toFixed(2)}}</td>
    <td class="has-text-link has-text-weight-bold" style="width: 67px;">{{calcData.yearsToRet.toFixed(2)}}</td>
    <td v-if="this.calcData.erf < 1" class="has-text-link has-text-weight-bold" style="width: 67px;">{{parseFloat(calcData.erf).toFixed(4)}}</td>
    <td class="has-text-link has-text-weight-bold" style="width: 157px;">{{calcData.perIncrease}}%</td>
    </tr>
    </tbody>
    </table>
  </div>


  <div class="box">
    <div class="content has-text-centered">
      <h6 class="title is-6">Explanation of Options</h6>
    </div>
    <div class="content">
      <sup style="color: red;">1</sup> <b>OPTION 1</b> - This monthly benefit is payable to only you, the member and will end upon your death. Upon your death, any balance remaining in your account will be paid to your beneficiary.<br><br>
      <sup style="color: red;">2</sup> <b>OPTION 2</b> - This monthly benefit is payable to you, the member, as long as you live. Upon your death, the same monthly benefit will continue to your contingent annuitant for their lifetime.<br><br>
      <sup style="color: red;">3</sup> <b>OPTION 3</b> - This monthly benefit is payable to you, the member, as long as you live. Upon your death, one half of the monthly benefit will continue to your contingent annuitant for their lifetime.<br><br>
      <sup style="color: red;">4</sup> <b>OPTION 4</b> - This monthly benefit is payable to you, the member, as long as you live. Upon your death, the monthly benefit will continue to your contingent annuitant(s) for the applicable period certain.<br><br>
      <sup style="color: red;">4a</sup>10-Year Period Certain -- You must be age 75 or younger when you retire to be eligible for this benefit. If you die before the 10-year period ends, then your contingent annuitant(s) will receive the benefit for the remainder of the 10-year period. The 10-year period begins on your effective date of retirement.<br><br>
      <sup style="color: red;">4b</sup>20-Year Period Certain -- You must be age 65 or younger when you retire to be eligible for this benefit. If you die before the 20-year period ends, then your contingent annuitant(s) will receive the benefit for the remainder of the 20-year period. The 20-year period begins on your effective date of retirement.<br>
    </div>  <!--- End of Content  -->
  </div>  <!--- End of Box  -->

</div>  <!--- End of Container  -->

    <!-- ============================================================================================================= -->

  <br>

  <section class="section">
    <div class="columns">
      <div class="column">
        <b-field horizontal>
          <button class="button" id="prevButton" v-on:click="gotoPage2()">
            <b-icon icon="arrow-left-bold"></b-icon>
            <span>Previous</span>
          </button>
        </b-field>
      </div>
      <div class="column">
      </div>
      <div class="column">
      </div>
      <div class="column">
      </div>
    </div>
  </section>
</div>
</template>


<script>

export default {
  name: "EstimatePage",
  data: function() {
    return {
      errMessag: "PAGE 3 message"
    }
  },
  props: ["calcData"],
  computed: {},
  methods: {
    gotoPage2: function(event) {
      this.$router.push('page02')
    },
    gotoPage3: function(event) {
      this.$router.push('Estimate')
    },
    currencyFormat: function(num) {
      return '$' + num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }
  },
};
</script>
